<template>
  <DefaultTable
    :headers="Object.keys(columns)"
    :highlight-rows="true"
    :pointer-hover="true"
  >
    <template
      v-if="loading"
      #rows
    >
      <tr class="tickets-row">
        <td
          class="text-center"
          :colspan="Object.keys(columns).length"
        >
          Loading...
          <i class="fa fas fa-spin fa-spinner" />
        </td>
      </tr>
    </template>

    <template
      v-else-if="supportTickets.length > 0"
      #rows
    >
      <tr
        v-for="ticket in supportTickets"
        :key="ticket.id"
        class="tickets-row"
        @click="viewTicket(ticket.id)"
      >
        <template
          v-for="(column, header) in columns"
          :key="header"
        >
          <td
            v-if="column.type === 'value'"
            class="text-center"
            v-text="ticket[column.column]"
          />

          <td v-if="column.type === 'date'">
            <ticket-due-date :date="ticket[column.column]" />
          </td>

          <template v-if="column.type === 'component'">
            <td v-if="column.name === 'summary'">
              <ticket-summary :ticket="ticket" />
            </td>

            <td v-if="column.name === 'status'">
              <ticket-status
                :status="ticket.status"
                :statuses="config.statuses"
              />
            </td>

            <td v-if="column.name === 'priority'">
              <ticket-priority
                :priority="ticket.priority"
                :priorities="config.priorities"
              />
            </td>

            <td v-if="column.name === 'user'">
              <ticket-user :user="ticket[column.column]" />
            </td>

            <td
              v-if="column.name === 'jira'"
              @click.stop=""
            >
              <jira-link
                :issue-key="ticket.jira_issue_key"
                :href="ticket.jira_link"
              />
            </td>
          </template>
        </template>
      </tr>
    </template>

    <template
      v-else
      #rows
    >
      <tr class="tickets-row">
        <td
          class="text-center"
          :colspan="Object.keys(columns).length"
        >
          Sorry, no tickets found...
        </td>
      </tr>
    </template>
  </DefaultTable>
</template>

<script>
import DefaultTable from "@/components/global/tables/DefaultTable.vue";
import TicketSummary from "@/components/support/table/TicketSummary.vue";
import TicketStatus from "@/components/support/table/TicketStatus.vue";
import TicketPriority from "@/components/support/table/TicketPriority.vue";
import TicketDueDate from "@/components/support/table/TicketDueDate.vue";
import TicketUser from "@/components/support/table/TicketUser.vue";
import JiraLink from "@/components/support/table/JiraLink.vue";

export default {
  components: {
    JiraLink,
    TicketUser,
    TicketDueDate,
    TicketPriority,
    TicketStatus,
    TicketSummary,
    DefaultTable
  },
  props: {
    supportTickets: {
      type: Array,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
    filter: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    columns() {
      return this.loading ? [] : this.config.filters[this.filter].columns;
    }
  },
  methods: {
    viewTicket(id) {
      location.href = `/support/${id}`;
    },
  },
}
</script>

